package br.com.vvrefeicoes.portal.core.util

import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Canvas
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.drawscope.CanvasDrawScope
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.toPixelMap
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.LayoutDirection
import kotlin.math.roundToInt

/**
 * Rasteriza um painter (composto sobre branco) para embutir no PDF.
 * Evita depender de assets raster ou de um codificador PNG/JPEG multiplataforma.
 * Deve ser chamado com o painter já carregado, por exemplo no clique do botão.
 */
fun Painter.toPdfImage(
    widthPx: Int,
    heightPx: Int,
): PdfImage {
    val bitmap = ImageBitmap(widthPx, heightPx)
    val canvas = Canvas(bitmap)
    CanvasDrawScope().draw(
        density = Density(1f),
        layoutDirection = LayoutDirection.Ltr,
        canvas = canvas,
        size = Size(widthPx.toFloat(), heightPx.toFloat()),
    ) {
        drawRect(Color.White)
        with(this@toPdfImage) { draw(size) }
    }
    val pixels = bitmap.toPixelMap()
    val rgb = ByteArray(widthPx * heightPx * 3)
    var index = 0
    for (y in 0 until heightPx) {
        for (x in 0 until widthPx) {
            val color = pixels[x, y]
            rgb[index++] = channel(color.red)
            rgb[index++] = channel(color.green)
            rgb[index++] = channel(color.blue)
        }
    }
    return PdfImage(width = widthPx, height = heightPx, rgb = rgb)
}

private fun channel(value: Float): Byte = (value * 255f).roundToInt().coerceIn(0, 255).toByte()
